import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import HomeScreen from "./Pages/HomeScreen";
import Onsites from "./Pages/Onsites";
import Annisites from "./Pages/Annisites";
import SingleEvent from "./Pages/SingleEvent";
import Messages from "./Pages/Messages";
import SingleDripp from "./Pages/SingleDripp";
import { AnimatePresence } from "framer-motion";
import AboutScreen from "./Pages/AboutScreen";
import ProfileScreen from "./Pages/ProfileScreen";
import PaymentCancel from "./Pages/PaymentCancel";
import PaymentSuccess from "./Pages/PaymentSuccess";
import ContactUs from "./Pages/ContactUs";
import AuthenticateScreen from "./Pages/AuthenticateScreen";
import ThankYou from "./Pages/ThankYou";
import AccessDenied from "./Pages/AccessDenied";
import TermsnConditions from "./Pages/TermsnConditions";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import RefundsTerminate from "./Pages/RefundsTerminate";
import Blogs from "./Pages/Blogs";
import BlogSingle from "./Pages/BlogSingle";
import HowTo from "./Pages/HowTo";

function App() {
  return (
    <>
      <Router>
          <div className="main-container">
            <AnimatePresence>
              <Routes>
                  <Route path="/about" element={<AboutScreen />}/> 
                  <Route path="/contact-us" element={<ContactUs />}/> 
                  <Route path="/" element={<HomeScreen />}/> 
                  <Route path="/onsites" element={<Onsites />}/> 
                  <Route path="/annisites" element={<Annisites />}/> 
                  <Route path="/couple-event/:id" element={<SingleEvent /> } /> 
                  <Route path="/messages" element={<Messages /> } /> 
                  <Route path="/single-dripp/:id" element={<SingleDripp />} />
                  <Route path="/profile" element={<ProfileScreen />} />
                  <Route path="/payment-success" element={<PaymentSuccess />} />
                  <Route path="/payment-cancel" element={<PaymentCancel />} />
                  <Route path="/authenticate" element={<AuthenticateScreen />} />
                  <Route path="/terms-n-conditions" element={<TermsnConditions />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/refunds-termination" element={<RefundsTerminate />} />
                  <Route path="/how-to" element={<HowTo />} />
                  <Route path="/blogs" element={<Blogs />} />
                  <Route path="/single-blog/:id" element={<BlogSingle />} />
                  <Route path="/thank-you" element={<ThankYou />} />
                  <Route path="/access-denied" element={<AccessDenied />} />
              </Routes>
            </AnimatePresence>
          </div>
      </Router>
    <ToastContainer />
    </>
  );
}

export default App;
